import VerificationVerify from './VerificationVerify';

export default VerificationVerify;
